import { EventEmitter } from '../util/eventemitter';

export interface ActiveBuff {
  skillIdx: number;
  statusEffectId: number;
  startedAt: number;
  durationMs: number;
}

export class BuffData extends EventEmitter {
  private buffs: Map<number, ActiveBuff>; // keyed by statusEffectId

  constructor() {
    super();
    this.buffs = new Map();
  }

  applyBuff(skillIdx: number, statusEffectId: number, durationMs: number): void {
    const entry: ActiveBuff = {
      skillIdx,
      statusEffectId,
      startedAt: Date.now(),
      durationMs,
    };
    this.buffs.set(statusEffectId, entry);
    this.emit('changed');

    setTimeout(() => {
      // A re-cast within the window replaces this entry with a fresh startedAt;
      // only remove it here if this timer's own entry is still the current one.
      if (this.buffs.get(statusEffectId) === entry) {
        this.buffs.delete(statusEffectId);
        this.emit('changed');
      }
    }, durationMs);
  }

  getActive(): ActiveBuff[] {
    return Array.from(this.buffs.values());
  }
}
